import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useBusiness } from '../contexts/BusinessContext';
import { useCart } from '../contexts/CartContext';
import WelcomeScreen from '../components/client/WelcomeScreen';
import MenuView from '../components/client/MenuView';
import CartView from '../components/client/CartView';
import CheckoutView from '../components/client/CheckoutView';
import AgencyLanding from './AgencyLanding';

const ClientView = () => {
  const { slug, step } = useParams();
  const { business, loading, error, loadBusiness } = useBusiness();
  const { setSlug, setDeliveryMode, setRoutePrefix } = useCart();

  useEffect(() => {
    if (slug) {
      setSlug(slug);
      setRoutePrefix(`/${slug}`); // Modo path-based: rutas llevan prefijo /slug
      loadBusiness(slug);
    }
  }, [slug]);

  // Sync deliveryMode from URL step
  useEffect(() => {
    if (step === 'delivery') setDeliveryMode('delivery');
    else if (step === 'takeaway') setDeliveryMode('takeaway');
  }, [step]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-yellow-400 mx-auto mb-4"></div>
          <p className="text-gray-400">Cargando...</p>
        </div>
      </div>
    );
  }

  if (error || !business) {
    return <AgencyLanding />;
  }

  // Determine which view to render based on URL step
  const renderView = () => {
    switch (step) {
      case 'delivery':
      case 'takeaway':
        return <MenuView />;
      case 'carrito':
        return <CartView />;
      case 'fin':
        return <CheckoutView />;
      default:
        // No step = welcome screen (/slug)
        return <WelcomeScreen />;
    }
  };

  return (
    <div className="min-h-screen" style={{ fontFamily: 'var(--font-body, Roboto, sans-serif)' }}>
      {renderView()}
    </div>
  );
};

export default ClientView;
